"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentLengthPlugin = exports.contentLengthMiddlewareOptions = exports.contentLengthMiddleware = void 0;
var protocols_1 = require("@smithy/core/protocols");
Object.defineProperty(exports, "contentLengthMiddleware", { enumerable: true, get: function () { return protocols_1.contentLengthMiddleware; } });
Object.defineProperty(exports, "contentLengthMiddlewareOptions", { enumerable: true, get: function () { return protocols_1.contentLengthMiddlewareOptions; } });
Object.defineProperty(exports, "getContentLengthPlugin", { enumerable: true, get: function () { return protocols_1.getContentLengthPlugin; } });
